import { Keys, createShortcutManagerInstance, shortcutManager, IShortcutDescriptorGroup, launchShortcutViewer } from "@pjs/core-ui";
import { IEditor } from "../../../editor/interfaces/IEditor";
import { richTextI18n } from "../../../i18n/RichTextI18n.const";
import { mapEditorKeysToShortcut } from "./MapEditorKeysToShortcuts.function";

export const displayShortcuts = (editor: IEditor): (() => void) => {
    const shortcutCallback = (evt: KeyboardEvent): void => {
        const editorInstance = editor.getInstance();

        if (editorInstance !== null) {
            evt.stopPropagation();

            const activeShortcuts: Array<IShortcutDescriptorGroup> = shortcutManager.getActiveShortcuts().sort((a, b) => {
                return a.description.localeCompare(b.description);
            });

            activeShortcuts.unshift(mapEditorKeysToShortcut(editorInstance.accessibility.keystrokeInfos));

            launchShortcutViewer(editor.sourceElement, activeShortcuts);
        }
    };

    const editorShortcutManager = createShortcutManagerInstance(editor.sourceElement);
    const removeEditorStack = editorShortcutManager.addStack();

    editorShortcutManager.add(
        [
            {
                keys: [Keys.Control, "/"],
                callback: shortcutCallback,
                description: richTextI18n.getString("editor_usv.trigger_description")
            }
        ],
        richTextI18n.getString("editor_usv.trigger_group_label")
    );

    return (): void => {
        editorShortcutManager.disableListeners();
        removeEditorStack();
    };
};
